import {createSelector} from 'reselect'
import {WorkflowStatusType} from './constants'
import {Feature, isEnabled} from '../features/index'
import {FAKE_OPEN_WORKFLOW_STATUS_ID, FAKE_COMPLETED_WORKFLOW_STATUS_ID} from './constants'
import {workflowStatusComparatorWithStatusType} from './utils'
import {getWorkflowStatuses} from '../entities/selectors'

export const selectStatusById = (state, id) => {
    return getWorkflowStatuses(state)[id]
}

export function selectStatusByTask(state, task) {

    return selectStatusById(state, selectStatusIdByTask(task))
}

export function selectStatusIdByTask(task) {
    let id
    if (isEnabled(Feature.TWS)) {
        id = task.workflowStatusId
    } else {
        id = selectFakeStatusIdByTaskComplete(task.completed)
    }
    return id
}

export function selectFakeStatusIdByTaskComplete(completed) {
    return completed ? FAKE_COMPLETED_WORKFLOW_STATUS_ID : FAKE_OPEN_WORKFLOW_STATUS_ID
}

export const getWorkflowStatusesList = createSelector(
    getWorkflowStatuses,
    (workflowStatusesMap) => Object.values(workflowStatusesMap)
)

export const getSortedWorkflowStatusList = createSelector(
    getWorkflowStatusesList,
    (workflowStatusesList) => workflowStatusesList.sort(workflowStatusComparatorWithStatusType)
)

export const getSortedOpenWorkflowStatusList = createSelector(
    getWorkflowStatusesList,
    (workflowStatusesList) => workflowStatusesList
        .filter(status => status.type === WorkflowStatusType.OPEN)
        .sort(workflowStatusComparatorWithStatusType)
)

export const getDefaultOpenWorkflowStatus = createSelector(
    getSortedOpenWorkflowStatusList,
    (wsList) => wsList[0]
)

export const getFirstCompletedWorkflowStatus = (state) => {
    return selectFirstStatusByType(state, WorkflowStatusType.COMPLETED)
}

export const selectFirstStatusByType = (state, type) => {
    return getSortedWorkflowStatusList(state).find(status => status.type === type)
}



// WEBPACK FOOTER //
// ./web/js/workflowStatus/selectors.js